const WalletAddressesEmpty = () => <div className='savedwalletaddress_nodata'></div>;

export default WalletAddressesEmpty;
